﻿<div class="global-messages">
    <vl-layout v-if="announcements && announcements.length > 0">
        <vl-form-grid>
            <vl-column>
                <div v-if="announcements">
                    <vl-u-spacer />
                    <vl-alert
                            :closable="true"
                            v-for="announcement in announcements"
                            :key="announcement.id"
                            :title="announcement.title"
                            @close="closeMessage(announcement.id)"
                            mod-warning>
                        <div v-html="announcement.message"></div>
                    </vl-alert>
                </div>
            </vl-column>
        </vl-form-grid>
    </vl-layout>
</div>
